import movingForwardPNG from '~/assets/images/communication/moving-forward.png'
import movingForwardWEBP from '~/assets/images/communication/moving-forward.webp'
import InfoPage from '~/pages/communication/libs/InfoPage'
import { TPageProps } from '~/shared/types/commonTypes'

const MovingForwardCommunication = (props: TPageProps) => (
  <InfoPage
    {...props}
    question="You're already moving forward"
    titleI18nKey="onboarding.communicationMovingForward.title"
    subtitleI18nKey="onboarding.communicationMovingForward.subtitle"
    imagePng={movingForwardPNG}
    imageWebp={movingForwardWEBP}
    imageAlt="You're already moving forward"
    contentGap={48}
  />
)

export default MovingForwardCommunication
